import React from 'react';
import BurgerMenu from '../../../svg/burgerMenu';
import MenuOpenX from '../../../svg/menuOpen';

const MobileHeader = ({ isOpen, onToggle }) => {
  return (
    <div className="mobile-header">
      <button 
        className="mobile-menu" 
        onClick={onToggle}
        aria-label={isOpen ? "Close navigation menu" : "Open navigation menu"}
        aria-expanded={isOpen}
      >
        {isOpen ? <MenuOpenX /> : <BurgerMenu />}
      </button>
    </div>
  );
};

export default MobileHeader;